import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import { PasskeyCreateDialog } from '@/components/dialogs/passkey-create-dialog';
import { SettingsHeader } from '@/components/settings-header';
import { SettingsSecurityPasskeyTable } from '@/components/tables/passkey-table';

export const PasskeyPage = () => {
  useLocale();

  return (
    <div className="raven-page raven-settings">
      <SettingsHeader
        hideDivider={true}
        subtitle={t('auth.manageYourPasskeys')}
        title={t('auth.passkeys')}
      >
        <PasskeyCreateDialog />
      </SettingsHeader>

      <div className="mt-4">
        <SettingsSecurityPasskeyTable />
      </div>
    </div>
  );
};
